export function toIsoDuration(durationInSeconds: number): string {
    if (durationInSeconds === 0) {
        return 'PT0S';
    }

    const hours = Math.floor(durationInSeconds / 3_600);
    const minutes = Math.floor((durationInSeconds % 3_600) / 60);
    const seconds = durationInSeconds % 60;

    return `PT${hours ? `${hours}H` : ''}${minutes ? `${minutes}M` : ''}${
        seconds ? `${seconds}S` : ''
    }`;
}
